import axios, { AxiosRequestConfig } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { PATHS } from '~fpu/config/constants';

function useUpdateCoordinatorProfile() {
  const config: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };

  return useMutation({
    mutationFn: (data: FormData) =>
      axios.put(PATHS.API.USER_METADATA, data, config)
  });
}

export { useUpdateCoordinatorProfile };
